<template>
  <!-- Product filter. Lives in the shared KarroFin store rather than in each
       page's own state, so the choice follows the user from Leads to Offers to
       Applications instead of resetting on every navigation. It used to be a
       button toggle in the module tab bar; it became a normal filter when the
       modules moved into the sidebar. -->
  <v-select
    :value="productType"
    :items="items"
    label="Product"
    hide-details
    dense
    outlined
    class="kf-select"
    @change="onChange"
  />
</template>

<script>
import store from "@/app-js/karrofin/store";
import { PRODUCT_FILTER_ALL, PRODUCT_TYPES } from "@/app-js/karrofin/constants";

export default {
  name: "KfProductSelect",
  data() {
    return {
      // "All" is a UI-only value; store.productTypeParam() maps it to null.
      items: [PRODUCT_FILTER_ALL].concat(PRODUCT_TYPES),
    };
  },
  computed: {
    productType() {
      return store.productType;
    },
  },
  methods: {
    onChange(value) {
      // Deliberately not clearable: an empty product filter and "All" mean the
      // same thing, and two ways of saying it invites bugs.
      store.setProductType(value || PRODUCT_FILTER_ALL);
      this.$emit("change", store.productType);
    },
  },
};
</script>
